<template>
  <vb-icon :name="icon" :color="color" :size="size" />
</template>

<script>
import { is_child, is_infant, is_teen } from "@liveflight/utilities";

export default {
  name: "traveler-icon",
  props: {
    traveler: {
      type: Object,
      required: true,
    },
    color: {
      type: String,
      default: () => "#000",
    },
    size: {
      type: Number,
      default: () => 18,
    },
  },
  computed: {
    icon() {
      if (is_infant(this.traveler)) {
        return "infant";
      }
      if (is_teen(this.traveler) || is_child(this.traveler)) {
        return "child";
      }
      return "user";
    },
  },
};
</script>
